(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var DRAWER_SELECTOR = '[data-cart-drawer]';
    var HEADER_SELECTOR = '.header-sworn';
    var debounceTimers = {};

    function getDrawer() {
      return document.querySelector(DRAWER_SELECTOR);
    }

    function openDrawer() {
      var drawer = getDrawer();
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var panel = drawer.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    }

    function closeDrawer() {
      var drawer = getDrawer();
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function replaceSection(html, selector) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector(selector);
      var current = document.querySelector(selector);
      if (fresh && current) {
        // Preserve open state on the drawer
        if (selector === DRAWER_SELECTOR) {
          var wasOpen = current.getAttribute('data-open') === 'true';
          fresh.setAttribute('data-open', wasOpen ? 'true' : 'false');
          fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
        }
        current.replaceWith(fresh);
      }
    }

    function updateLine(key, qty) {
      fetch('/cart/change.js?sections=cart-drawer,header-sworn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.sections) {
            replaceSection(data.sections['cart-drawer'], DRAWER_SELECTOR);
            replaceSection(data.sections['header-sworn'], HEADER_SELECTOR);
          }
        })
        .catch(function (err) {
          console.error('Cart update failed:', err);
        });
    }

    document.addEventListener('cart-drawer:open', openDrawer);
    document.addEventListener('cart-drawer:close', closeDrawer);

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) {
        event.preventDefault();
        openDrawer();
        return;
      }

      var closeTrigger = event.target.closest('[data-cart-drawer-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        updateLine(removeBtn.getAttribute('data-line-key'), 0);
        return;
      }

      var stepBtn = event.target.closest('[data-cart-qty-step]');
      if (stepBtn) {
        event.preventDefault();
        var step = parseInt(stepBtn.getAttribute('data-cart-qty-step'), 10) || 0;
        var key = stepBtn.getAttribute('data-line-key');
        var input = document.querySelector('[data-cart-qty][data-line-key="' + key + '"]');
        if (!input) return;
        var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = newQty;
        updateLine(key, newQty);
        return;
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-qty]');
      if (!input) return;
      var key = input.getAttribute('data-line-key');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = qty;
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(function () {
        updateLine(key, qty);
      }, 250);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var drawer = getDrawer();
      if (drawer && drawer.getAttribute('data-open') === 'true') {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PAGE_SELECTOR = '[data-cart-page]';
    var HEADER_SELECTOR = '.header-sworn';
    var DRAWER_SELECTOR = '[data-cart-drawer]';
    var debounceTimers = {};

    function replaceSection(html, selector) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector(selector);
      var current = document.querySelector(selector);
      if (!fresh || !current) return;

      if (selector === DRAWER_SELECTOR) {
        var wasOpen = current.getAttribute('data-open') === 'true';
        fresh.setAttribute('data-open', wasOpen ? 'true' : 'false');
        fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
      }
      current.replaceWith(fresh);
    }

    function updateLine(key, qty) {
      fetch('/cart/change.js?sections=cart,cart-drawer,header-sworn', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.sections) return;
          replaceSection(data.sections['cart'], PAGE_SELECTOR);
          replaceSection(data.sections['cart-drawer'], DRAWER_SELECTOR);
          replaceSection(data.sections['header-sworn'], HEADER_SELECTOR);
        })
        .catch(function (err) {
          console.error('Cart update failed:', err);
        });
    }

    document.addEventListener('click', function (event) {
      var page = event.target.closest(PAGE_SELECTOR);
      if (!page) return;

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        updateLine(removeBtn.getAttribute('data-line-key'), 0);
        return;
      }

      var stepBtn = event.target.closest('[data-cart-qty-step]');
      if (stepBtn) {
        event.preventDefault();
        var step = parseInt(stepBtn.getAttribute('data-cart-qty-step'), 10) || 0;
        var key = stepBtn.getAttribute('data-line-key');
        var input = page.querySelector('[data-cart-qty][data-line-key="' + key + '"]');
        if (!input) return;
        var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = newQty;
        updateLine(key, newQty);
        return;
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-qty]');
      if (!input) return;
      if (!input.closest(PAGE_SELECTOR)) return;
      var key = input.getAttribute('data-line-key');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = qty;
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(function () {
        updateLine(key, qty);
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured-product').forEach(function (section) {
      var tabs = section.querySelectorAll('[data-tab]');
      var panels = section.querySelectorAll('[data-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tab;
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.panel === target);
          });
        });
      });

      // Read more — one-way expand. Button hides once opened.
      var readMoreBtn = section.querySelector('[data-read-more]');
      var detailsWrap = section.querySelector('[data-details-wrap]');

      if (readMoreBtn && detailsWrap) {
        // Mark "header paragraphs" (a <p> whose only child is a <strong>) so
        // CSS can style them as section headings. This bullet-proofs against
        // browsers without :has() support.
        var content = detailsWrap.querySelector('.featured-product__details-content');
        if (content) {
          content.querySelectorAll('p').forEach(function (p) {
            // Trim text nodes — if the only meaningful child is <strong>, mark it
            var children = Array.from(p.childNodes).filter(function (n) {
              if (n.nodeType === 3) return n.textContent.trim().length > 0; // text node
              return true;
            });
            if (
              children.length === 1 &&
              children[0].nodeType === 1 &&
              children[0].tagName === 'STRONG'
            ) {
              p.classList.add('is-heading');
            }
          });
        }

        // If content fits within collapsed height, hide the button + fade entirely.
        var checkOverflow = function () {
          if (detailsWrap.classList.contains('is-open')) return;
          if (!content) return;
          var collapsedHeight = detailsWrap.clientHeight;
          var fullHeight = content.scrollHeight;
          if (fullHeight <= collapsedHeight + 4) {
            readMoreBtn.style.display = 'none';
            var fade = detailsWrap.querySelector('.featured-product__details-fade');
            if (fade) fade.style.display = 'none';
            detailsWrap.style.maxHeight = 'none';
          }
        };

        if (document.readyState === 'complete') {
          checkOverflow();
        } else {
          window.addEventListener('load', checkOverflow);
        }
        window.addEventListener('resize', checkOverflow);

        readMoreBtn.addEventListener('click', function () {
          detailsWrap.classList.add('is-open');
          readMoreBtn.setAttribute('aria-expanded', 'true');
          setTimeout(function () {
            readMoreBtn.classList.add('is-hidden');
          }, 200);
        });
      }

      var form = section.querySelector('.featured-product__form');
      var buyNow = section.querySelector('[data-buy-now]');
      var atc = section.querySelector('.featured-product__atc');

      function refreshCartSections() {
        return fetch('/?sections=cart-drawer,header-sworn', {
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (!data) return;
            ['cart-drawer', 'header-sworn'].forEach(function (key) {
              var html = data[key];
              if (!html) return;
              var selector = key === 'cart-drawer' ? '[data-cart-drawer]' : '.header-sworn';
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var fresh = tmp.querySelector(selector);
              var current = document.querySelector(selector);
              if (fresh && current) {
                if (selector === '[data-cart-drawer]') {
                  var wasOpen = current.getAttribute('data-open') === 'true';
                  fresh.setAttribute('data-open', wasOpen ? 'true' : 'false');
                  fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
                }
                current.replaceWith(fresh);
              }
            });
          });
      }

      if (form && atc) {
        form.addEventListener('submit', function (event) {
          if (event.submitter && event.submitter.hasAttribute('data-buy-now')) return;
          event.preventDefault();
          if (atc.disabled) return;
          atc.disabled = true;

          var formData = new FormData(form);
          formData.set('sections', 'cart-drawer,header-sworn');

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          })
            .then(function (response) {
              if (!response.ok) {
                return response.json().then(function (err) {
                  throw new Error(err.description || 'Could not add to cart');
                });
              }
              return response.json();
            })
            .then(function (data) {
              if (data && data.sections) {
                ['cart-drawer', 'header-sworn'].forEach(function (key) {
                  var html = data.sections[key];
                  if (!html) return;
                  var selector = key === 'cart-drawer' ? '[data-cart-drawer]' : '.header-sworn';
                  var tmp = document.createElement('div');
                  tmp.innerHTML = html;
                  var fresh = tmp.querySelector(selector);
                  var current = document.querySelector(selector);
                  if (fresh && current) current.replaceWith(fresh);
                });
                document.dispatchEvent(new CustomEvent('cart-drawer:open'));
              } else {
                refreshCartSections().then(function () {
                  document.dispatchEvent(new CustomEvent('cart-drawer:open'));
                });
              }
            })
            .catch(function (err) {
              console.error('Add to cart failed:', err);
              alert(err.message || 'Could not add to cart');
            })
            .finally(function () {
              atc.disabled = false;
            });
        });
      }

      if (!buyNow) return;

      buyNow.addEventListener('click', function (event) {
        event.preventDefault();
        if (!form) return;

        if (buyNow.disabled) return;
        buyNow.disabled = true;

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            if (response.ok) {
              window.location.href = '/checkout';
              return null;
            }
            return response.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          })
          .catch(function (err) {
            buyNow.disabled = false;
            console.error('Buy now failed:', err);
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["five-minute-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.five-minute-look').forEach(function (section) {
      // Infinite-loop carousel
      var container = section.querySelector('.five-minute-look__cards');
      if (container) {
        var originals = Array.from(container.children);
        var n = originals.length;
        if (n > 1) {
          var clones = [];
          var jumping = false;
          var scrollEndTimer = null;
          var initialized = false;

          var prevBtn = section.querySelector('.five-minute-look__arrow--prev');
          var nextBtn = section.querySelector('.five-minute-look__arrow--next');

          function getCards() {
            return Array.from(container.children);
          }

          function addClones() {
            for (var i = n - 1; i >= 0; i--) {
              var pre = originals[i].cloneNode(true);
              pre.dataset.clone = 'true';
              pre.setAttribute('aria-hidden', 'true');
              container.insertBefore(pre, container.firstChild);
              clones.push(pre);
            }
            for (var j = 0; j < n; j++) {
              var post = originals[j].cloneNode(true);
              post.dataset.clone = 'true';
              post.setAttribute('aria-hidden', 'true');
              container.appendChild(post);
              clones.push(post);
            }
          }

          function scrollToInstant(card) {
            if (!card) return;
            var prev = container.style.scrollSnapType;
            container.style.scrollSnapType = 'none';
            container.scrollLeft = card.offsetLeft - (container.offsetWidth - card.offsetWidth) / 2;
            container.offsetHeight;
            container.style.scrollSnapType = prev;
          }

          function findCenterIndex() {
            var cards = getCards();
            var rect = container.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var minDist = Infinity;
            var idx = -1;
            cards.forEach(function (card, i) {
              var cr = card.getBoundingClientRect();
              var cc = cr.left + cr.width / 2;
              var d = Math.abs(cx - cc);
              if (d < minDist) {
                minDist = d;
                idx = i;
              }
            });
            return idx;
          }

          function checkLoop() {
            if (jumping || !initialized) return;
            var idx = findCenterIndex();
            if (idx === -1) return;
            var cards = getCards();
            var target = null;
            if (idx < n) target = cards[idx + n];
            else if (idx >= 2 * n) target = cards[idx - n];
            if (target) {
              jumping = true;
              scrollToInstant(target);
              requestAnimationFrame(function () {
                jumping = false;
              });
            }
          }

          function init() {
            if (!initialized) {
              addClones();
              initialized = true;
              requestAnimationFrame(function () {
                scrollToInstant(getCards()[n]);
              });
            }
          }

          container.addEventListener('scroll', function () {
            if (jumping) return;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkLoop, 150);
          }, { passive: true });

          function step(direction) {
            var cards = getCards();
            if (cards.length === 0) return;
            var idx = findCenterIndex();
            if (idx === -1) idx = n;
            var target = cards[idx + direction];
            if (!target) return;
            container.scrollTo({
              left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }

          if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

          init();

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              scrollToInstant(getCards()[n]);
            }, 150);
          });
        }
      }

      // Lightbox open/close
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.five-minute-look__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.five-minute-look__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-face-one-lipstick"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.full-face-one-lipstick').forEach(function (section) {
      // Infinite-loop carousel
      var container = section.querySelector('.full-face-one-lipstick__cards');
      if (container) {
        var originals = Array.from(container.children);
        var n = originals.length;
        if (n > 1) {
          var clones = [];
          var jumping = false;
          var scrollEndTimer = null;
          var initialized = false;

          var prevBtn = section.querySelector('.full-face-one-lipstick__arrow--prev');
          var nextBtn = section.querySelector('.full-face-one-lipstick__arrow--next');

          function getCards() {
            return Array.from(container.children);
          }

          function addClones() {
            for (var i = n - 1; i >= 0; i--) {
              var pre = originals[i].cloneNode(true);
              pre.dataset.clone = 'true';
              pre.setAttribute('aria-hidden', 'true');
              container.insertBefore(pre, container.firstChild);
              clones.push(pre);
            }
            for (var j = 0; j < n; j++) {
              var post = originals[j].cloneNode(true);
              post.dataset.clone = 'true';
              post.setAttribute('aria-hidden', 'true');
              container.appendChild(post);
              clones.push(post);
            }
          }

          function scrollToInstant(card) {
            if (!card) return;
            var prev = container.style.scrollSnapType;
            container.style.scrollSnapType = 'none';
            container.scrollLeft = card.offsetLeft - (container.offsetWidth - card.offsetWidth) / 2;
            container.offsetHeight;
            container.style.scrollSnapType = prev;
          }

          function findCenterIndex() {
            var cards = getCards();
            var rect = container.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var minDist = Infinity;
            var idx = -1;
            cards.forEach(function (card, i) {
              var cr = card.getBoundingClientRect();
              var cc = cr.left + cr.width / 2;
              var d = Math.abs(cx - cc);
              if (d < minDist) {
                minDist = d;
                idx = i;
              }
            });
            return idx;
          }

          function checkLoop() {
            if (jumping || !initialized) return;
            var idx = findCenterIndex();
            if (idx === -1) return;
            var cards = getCards();
            var target = null;
            if (idx < n) target = cards[idx + n];
            else if (idx >= 2 * n) target = cards[idx - n];
            if (target) {
              jumping = true;
              scrollToInstant(target);
              requestAnimationFrame(function () {
                jumping = false;
              });
            }
          }

          function init() {
            if (!initialized) {
              addClones();
              initialized = true;
              requestAnimationFrame(function () {
                scrollToInstant(getCards()[n]);
              });
            }
          }

          container.addEventListener('scroll', function () {
            if (jumping) return;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkLoop, 150);
          }, { passive: true });

          function step(direction) {
            var cards = getCards();
            if (cards.length === 0) return;
            var idx = findCenterIndex();
            if (idx === -1) idx = n;
            var target = cards[idx + direction];
            if (!target) return;
            container.scrollTo({
              left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }

          if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

          init();

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              scrollToInstant(getCards()[n]);
            }, 150);
          });
        }
      }

      // Lightbox open/close
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.full-face-one-lipstick__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.full-face-one-lipstick__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sworn"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.header-sworn').forEach(function (header) {
      var toggle = header.querySelector('.header-sworn__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = header.getAttribute('data-open') === 'true';
        header.setAttribute('data-open', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });

      var mq = window.matchMedia('(min-width: 769px)');
      var reset = function (e) {
        if (e.matches) {
          header.setAttribute('data-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
        }
      };
      if (mq.addEventListener) {
        mq.addEventListener('change', reset);
      } else if (mq.addListener) {
        mq.addListener(reset);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-apply"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.how-to-apply').forEach(function (section) {
      // Infinite-loop carousel
      var container = section.querySelector('.how-to-apply__cards');
      if (container) {
        var originals = Array.from(container.children);
        var n = originals.length;
        if (n > 1) {
          var clones = [];
          var jumping = false;
          var scrollEndTimer = null;
          var initialized = false;

          var prevBtn = section.querySelector('.how-to-apply__arrow--prev');
          var nextBtn = section.querySelector('.how-to-apply__arrow--next');

          function getCards() {
            return Array.from(container.children);
          }

          function addClones() {
            for (var i = n - 1; i >= 0; i--) {
              var pre = originals[i].cloneNode(true);
              pre.dataset.clone = 'true';
              pre.setAttribute('aria-hidden', 'true');
              container.insertBefore(pre, container.firstChild);
              clones.push(pre);
            }
            for (var j = 0; j < n; j++) {
              var post = originals[j].cloneNode(true);
              post.dataset.clone = 'true';
              post.setAttribute('aria-hidden', 'true');
              container.appendChild(post);
              clones.push(post);
            }
          }

          function scrollToInstant(card) {
            if (!card) return;
            var prev = container.style.scrollSnapType;
            container.style.scrollSnapType = 'none';
            container.scrollLeft = card.offsetLeft - (container.offsetWidth - card.offsetWidth) / 2;
            container.offsetHeight;
            container.style.scrollSnapType = prev;
          }

          function findCenterIndex() {
            var cards = getCards();
            var rect = container.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var minDist = Infinity;
            var idx = -1;
            cards.forEach(function (card, i) {
              var cr = card.getBoundingClientRect();
              var cc = cr.left + cr.width / 2;
              var d = Math.abs(cx - cc);
              if (d < minDist) {
                minDist = d;
                idx = i;
              }
            });
            return idx;
          }

          function checkLoop() {
            if (jumping || !initialized) return;
            var idx = findCenterIndex();
            if (idx === -1) return;
            var cards = getCards();
            var target = null;
            if (idx < n) target = cards[idx + n];
            else if (idx >= 2 * n) target = cards[idx - n];
            if (target) {
              jumping = true;
              scrollToInstant(target);
              requestAnimationFrame(function () {
                jumping = false;
              });
            }
          }

          function init() {
            if (!initialized) {
              addClones();
              initialized = true;
              requestAnimationFrame(function () {
                scrollToInstant(getCards()[n]);
              });
            }
          }

          container.addEventListener('scroll', function () {
            if (jumping) return;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkLoop, 150);
          }, { passive: true });

          function step(direction) {
            var cards = getCards();
            if (cards.length === 0) return;
            var idx = findCenterIndex();
            if (idx === -1) idx = n;
            var target = cards[idx + direction];
            if (!target) return;
            container.scrollTo({
              left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }

          if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

          init();

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              scrollToInstant(getCards()[n]);
            }, 150);
          });
        }
      }

      // Lightbox open/close
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.how-to-apply__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.how-to-apply__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kim-k-pout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.kim-k-pout').forEach(function (section) {
      // Infinite-loop carousel
      var container = section.querySelector('.kim-k-pout__cards');
      if (container) {
        var originals = Array.from(container.children);
        var n = originals.length;
        if (n > 1) {
          var clones = [];
          var jumping = false;
          var scrollEndTimer = null;
          var initialized = false;

          var prevBtn = section.querySelector('.kim-k-pout__arrow--prev');
          var nextBtn = section.querySelector('.kim-k-pout__arrow--next');

          function getCards() {
            return Array.from(container.children);
          }

          function addClones() {
            for (var i = n - 1; i >= 0; i--) {
              var pre = originals[i].cloneNode(true);
              pre.dataset.clone = 'true';
              pre.setAttribute('aria-hidden', 'true');
              container.insertBefore(pre, container.firstChild);
              clones.push(pre);
            }
            for (var j = 0; j < n; j++) {
              var post = originals[j].cloneNode(true);
              post.dataset.clone = 'true';
              post.setAttribute('aria-hidden', 'true');
              container.appendChild(post);
              clones.push(post);
            }
          }

          function scrollToInstant(card) {
            if (!card) return;
            var prev = container.style.scrollSnapType;
            container.style.scrollSnapType = 'none';
            container.scrollLeft = card.offsetLeft - (container.offsetWidth - card.offsetWidth) / 2;
            container.offsetHeight;
            container.style.scrollSnapType = prev;
          }

          function findCenterIndex() {
            var cards = getCards();
            var rect = container.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var minDist = Infinity;
            var idx = -1;
            cards.forEach(function (card, i) {
              var cr = card.getBoundingClientRect();
              var cc = cr.left + cr.width / 2;
              var d = Math.abs(cx - cc);
              if (d < minDist) {
                minDist = d;
                idx = i;
              }
            });
            return idx;
          }

          function checkLoop() {
            if (jumping || !initialized) return;
            var idx = findCenterIndex();
            if (idx === -1) return;
            var cards = getCards();
            var target = null;
            if (idx < n) target = cards[idx + n];
            else if (idx >= 2 * n) target = cards[idx - n];
            if (target) {
              jumping = true;
              scrollToInstant(target);
              requestAnimationFrame(function () {
                jumping = false;
              });
            }
          }

          function init() {
            if (!initialized) {
              addClones();
              initialized = true;
              requestAnimationFrame(function () {
                scrollToInstant(getCards()[n]);
              });
            }
          }

          container.addEventListener('scroll', function () {
            if (jumping) return;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkLoop, 150);
          }, { passive: true });

          function step(direction) {
            var cards = getCards();
            if (cards.length === 0) return;
            var idx = findCenterIndex();
            if (idx === -1) idx = n;
            var target = cards[idx + direction];
            if (!target) return;
            container.scrollTo({
              left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }

          if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

          init();

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              scrollToInstant(getCards()[n]);
            }, 150);
          });
        }
      }

      // Lightbox open/close
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.kim-k-pout__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.kim-k-pout__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.my-story').forEach(function (section) {
      var wrap = section.querySelector('[data-more-wrap]');
      var btn = section.querySelector('[data-more]');
      if (!wrap || !btn) return;
      btn.addEventListener('click', function () {
        section.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.page-testimonials').forEach(function (section) {
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.page-testimonials__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.page-testimonials__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

      var moreBtn = section.querySelector('[data-more]');
      if (moreBtn) {
        section.classList.add('page-testimonials--collapsed');
        moreBtn.hidden = false;
        moreBtn.addEventListener('click', function () {
          section.classList.remove('page-testimonials--collapsed');
          moreBtn.setAttribute('aria-expanded', 'true');
          moreBtn.hidden = true;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabrina-glam"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sabrina-glam').forEach(function (section) {
      // Infinite-loop carousel
      var container = section.querySelector('.sabrina-glam__cards');
      if (container) {
        var originals = Array.from(container.children);
        var n = originals.length;
        if (n > 1) {
          var clones = [];
          var jumping = false;
          var scrollEndTimer = null;
          var initialized = false;

          var prevBtn = section.querySelector('.sabrina-glam__arrow--prev');
          var nextBtn = section.querySelector('.sabrina-glam__arrow--next');

          function getCards() {
            return Array.from(container.children);
          }

          function addClones() {
            for (var i = n - 1; i >= 0; i--) {
              var pre = originals[i].cloneNode(true);
              pre.dataset.clone = 'true';
              pre.setAttribute('aria-hidden', 'true');
              container.insertBefore(pre, container.firstChild);
              clones.push(pre);
            }
            for (var j = 0; j < n; j++) {
              var post = originals[j].cloneNode(true);
              post.dataset.clone = 'true';
              post.setAttribute('aria-hidden', 'true');
              container.appendChild(post);
              clones.push(post);
            }
          }

          function scrollToInstant(card) {
            if (!card) return;
            var prev = container.style.scrollSnapType;
            container.style.scrollSnapType = 'none';
            container.scrollLeft = card.offsetLeft - (container.offsetWidth - card.offsetWidth) / 2;
            container.offsetHeight;
            container.style.scrollSnapType = prev;
          }

          function findCenterIndex() {
            var cards = getCards();
            var rect = container.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var minDist = Infinity;
            var idx = -1;
            cards.forEach(function (card, i) {
              var cr = card.getBoundingClientRect();
              var cc = cr.left + cr.width / 2;
              var d = Math.abs(cx - cc);
              if (d < minDist) {
                minDist = d;
                idx = i;
              }
            });
            return idx;
          }

          function checkLoop() {
            if (jumping || !initialized) return;
            var idx = findCenterIndex();
            if (idx === -1) return;
            var cards = getCards();
            var target = null;
            if (idx < n) target = cards[idx + n];
            else if (idx >= 2 * n) target = cards[idx - n];
            if (target) {
              jumping = true;
              scrollToInstant(target);
              requestAnimationFrame(function () {
                jumping = false;
              });
            }
          }

          function init() {
            if (!initialized) {
              addClones();
              initialized = true;
              requestAnimationFrame(function () {
                scrollToInstant(getCards()[n]);
              });
            }
          }

          container.addEventListener('scroll', function () {
            if (jumping) return;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkLoop, 150);
          }, { passive: true });

          function step(direction) {
            var cards = getCards();
            if (cards.length === 0) return;
            var idx = findCenterIndex();
            if (idx === -1) idx = n;
            var target = cards[idx + direction];
            if (!target) return;
            container.scrollTo({
              left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }

          if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
          if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

          init();

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              scrollToInstant(getCards()[n]);
            }, 150);
          });
        }
      }

      // Lightbox open/close
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.sabrina-glam__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.sabrina-glam__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.testimonials').forEach(function (section) {
      section.querySelectorAll('[data-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.play;
          var dialog = section.querySelector('[data-lightbox="' + id + '"]');
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          var video = dialog.querySelector('video');
          if (video) {
            try {
              video.currentTime = 0;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        });
      });

      section.querySelectorAll('.testimonials__lightbox').forEach(function (dialog) {
        function close() {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        var closeBtn = dialog.querySelector('.testimonials__lightbox-close');
        if (closeBtn) closeBtn.addEventListener('click', close);

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) close();
        });

        dialog.addEventListener('close', function () {
          var video = dialog.querySelector('video');
          if (video) { try { video.pause(); } catch (e) {} }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ways-to-wear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ways-to-wear').forEach(function (section) {
      var container = section.querySelector('.ways-to-wear__images');
      if (!container) return;

      var prevBtn = section.querySelector('.ways-to-wear__arrow--prev');
      var nextBtn = section.querySelector('.ways-to-wear__arrow--next');

      var originals = Array.from(container.children);
      var n = originals.length;
      if (n === 0) return;

      var clones = [];
      var jumping = false;
      var scrollEndTimer = null;
      var initialized = false;

      function getImages() {
        return Array.from(container.children);
      }

      function addClones() {
        for (var i = n - 1; i >= 0; i--) {
          var pre = originals[i].cloneNode(true);
          pre.dataset.clone = 'true';
          pre.setAttribute('aria-hidden', 'true');
          container.insertBefore(pre, container.firstChild);
          clones.push(pre);
        }
        for (var j = 0; j < n; j++) {
          var post = originals[j].cloneNode(true);
          post.dataset.clone = 'true';
          post.setAttribute('aria-hidden', 'true');
          container.appendChild(post);
          clones.push(post);
        }
      }

      function removeClones() {
        clones.forEach(function (c) { c.remove(); });
        clones = [];
      }

      function scrollToInstant(img) {
        if (!img) return;
        var prev = container.style.scrollSnapType;
        container.style.scrollSnapType = 'none';
        container.scrollLeft = img.offsetLeft - (container.offsetWidth - img.offsetWidth) / 2;
        container.offsetHeight;
        container.style.scrollSnapType = prev;
      }

      function findCenterIndex() {
        var images = getImages();
        var rect = container.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var minDist = Infinity;
        var idx = -1;
        images.forEach(function (img, i) {
          var ir = img.getBoundingClientRect();
          var ic = ir.left + ir.width / 2;
          var d = Math.abs(cx - ic);
          if (d < minDist) {
            minDist = d;
            idx = i;
          }
        });
        return idx;
      }

      function updateActive() {
        var images = getImages();
        var idx = findCenterIndex();
        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === idx);
        });
      }

      function checkLoop() {
        if (jumping || !initialized) return;
        var idx = findCenterIndex();
        if (idx === -1) return;
        var images = getImages();
        var target = null;
        if (idx < n) target = images[idx + n];
        else if (idx >= 2 * n) target = images[idx - n];
        if (target) {
          jumping = true;
          scrollToInstant(target);
          requestAnimationFrame(function () {
            jumping = false;
            updateActive();
          });
        }
      }

      function init() {
        if (!initialized) {
          addClones();
          initialized = true;
          requestAnimationFrame(function () {
            scrollToInstant(getImages()[n + 1]);
            updateActive();
          });
        }
      }

      container.addEventListener('scroll', function () {
        if (jumping) return;
        updateActive();
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(checkLoop, 150);
      }, { passive: true });

      function step(direction) {
        var images = getImages();
        if (images.length === 0) return;
        var idx = findCenterIndex();
        if (idx === -1) idx = n;
        var target = images[idx + direction];
        if (!target) return;
        container.scrollTo({
          left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () { step(-1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { step(1); });
      }

      init();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
